import { ThemeOptions } from '@mui/material';
import Images from './images';
import { ROUTES } from '../helpers/contants';

export interface Navigation {
  name: string;
  path: Array<string>;
  icon: any;
  icon_active: any;
  childs?: any;
}
export const s3Url =
  process.env.mode === 'preprod'
    ? process.env.IMG_SERVE_URL
    : process.env.S3_URL || '';

export const ORDER_PRODUCT_STATUS: any = {
  PLACED: 'Order Placed',
  PENDING: 'PENDING',
  ACCEPTED: 'Accepted',
  REJECTED: 'Rejected',
  COMPLETED: 'Completed',
  CANCELLED: 'Cancelled',
  DELIVERED: 'Delivered',
  INPROGRESS: 'INPROGRESS',
  RETURNED: 'RETURNED',
  SHIPPED: 'Shipped',
  INTRANSIT: 'In Transit',
  ENDED: 'Service Ended',
  STARTED: 'Service Started',
  APPROVED: 'APPROVED',
  INREVIEW: 'IN_REVIEW',
};
export const enum INVOICE_STATUS {
  PAID = 'PAID',
  UNPAID = 'UNPAID',
}
export const enum INVOICE_REQUEST_STATUS {
  ALL = 'ALL',
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  QUERY_RAISED = 'QUERY_RAISED',
}
export const enum PRODUCT_TYPES {
  RENTAL = 'RENTAL',
  VENDOR = 'VENDOR',
  SERVICE = 'SERVICE',
  PACKAGE = 'PACKAGE',
  VENDOR_PRODUCT = 'VENDOR_PRODUCT',
  VENDOR_SERVICES = 'VENDOR_SERVICE',
  PRODUCT = 'PRODUCT',
  PURCHASE = 'PURCHASE',
  PURCHASE_AND_RENTAL = 'RENTAL_AND_PURCHASE',
}
export const enum RENTAL_SERVICE_TYPE {
  BUY = 'BUY',
  RENT = 'RENT',
  SERVICE = 'SERVICE',
  PER_HOUR = 'PER_HOUR',
  BASE_RATE = 'BASE_RATE',
  MINIMUM_RATE = 'MINIMUM_RATE',
  PER_DAY_WEEK_MONTH = 'PER_DAY_WEEK_MONTH',
}
export const navigation: Navigation[] = [
  {
    name: 'Dashboard',
    path: [
      '/',
      '/production-dashboard',
      '/episode-dashboard',
      '/set-dashboard',
      '/location-dashboard',
      '/studio-dashboard',
      '/active-orders',
      '/crew-members',
      '/active-documents',
      '/total_sets_location',
      '/total-productions',
      '/total_episodes',
      '/total_sets',
      '/total_locations',
      '/active-location-set',
      '',
      '/total-production-episode',
      '/view-all-contacts-crew',
      '/view-all-documents',
      '/active-sets',
    ],
    icon: Images.DASHBOARD_ACTIVE,
    icon_active: Images.DASHBOARD_ACTIVE,
  },
  {
    name: 'Production',
    path: [
      ROUTES.MY_PRODUCTION,
      ROUTES.MY_EPISODE,
      ROUTES.MY_SET,
      ROUTES.MY_LOCATIONS,
    ],
    icon: Images.PRODUCTION_ACTIVE,
    icon_active: Images.PRODUCTION_ACTIVE,
    childs: [
      {
        name: 'My Project/Live Event',
        path: [ROUTES.MY_PRODUCTION],
        icon: Images.PRODUCTION_ACTIVE,
        icon_active: Images.PRODUCTION_ACTIVE,
      },
      {
        name: 'My Episode/Event',
        path: [ROUTES.MY_EPISODE],
        icon: Images.PRODUCTION_ACTIVE,
        icon_active: Images.PRODUCTION_ACTIVE,
      },
      {
        name: 'My Sets/Activity',
        path: [ROUTES.MY_SET],
        icon: Images.PRODUCTION_ACTIVE,
        icon_active: Images.PRODUCTION_ACTIVE,
      },
      {
        name: 'My Locations',
        path: [ROUTES.MY_LOCATIONS],
        icon: Images.PRODUCTION_ACTIVE,
        icon_active: Images.PRODUCTION_ACTIVE,
      },
    ],
  },
  {
    name: 'Schedule',
    path: ['/schedular'],
    icon: Images.ScheduleIcon,
    icon_active: Images.ScheduleIconActive,
  },
  {
    name: 'Finance',
    path: [
      ROUTES.FINANCE,
      ROUTES.PRODUCTION_SPENDINGS,
      ROUTES.SET_SPENDINGS,
      ROUTES.EPISODE_SPENDINGS,
      ROUTES.LOCATION_SPENDINGS,
      ROUTES.DEPARTMENT_SPENDINGS,
      ROUTES.SPENDINGS,
    ],
    icon: Images.FinanceIcon,
    icon_active: Images.FinanceIcon,
  },
  {
    name: 'Invoice',
    path: [
      ROUTES.INVOICES,
      ROUTES.INVOICE_REQUESTS,
      ROUTES.INVOICE_DETAIL,
      ROUTES.WORKSHEET,
    ],
    icon: Images.InvoiceIcon,
    icon_active: Images.InvoiceIcon,
    childs: [
      {
        name: 'Invoices',
        path: [ROUTES.INVOICES, ROUTES.INVOICE_DETAIL],
        icon: Images.InvoiceIcon,
        icon_active: Images.InvoiceIcon,
      },
      {
        name: 'Invoice Requests',
        path: [ROUTES.INVOICE_REQUESTS],
        icon: Images.InvoiceIcon,
        icon_active: Images.InvoiceIcon,
      },
    ],
  },
  {
    name: 'Payment History',
    path: [ROUTES.PAYMENT_HISTORY],
    icon: Images.PaymentIcon,
    icon_active: Images.PaymentIcon,
  },

  // {
  //   name: 'Risk & Safety',
  //   path: [
  //     '/risk',
  //     '/event-detail',
  //     '/user-detail',
  //     '/book-service',
  //     '/booking-details',
  //   ],
  //   icon: Images.RISK_IC,
  //   icon_active: Images.RISK_IC,
  // },
  {
    name: 'Documents',
    path: ['/my-document', '/upload-document'],
    icon: Images.DocumentIcon,
    icon_active: Images.DocumentIcon,
  },

  {
    name: 'Orders',
    path: [
      ROUTES.ORDERS_LIST,
      ROUTES.ORDER_DETAILS,
      ROUTES.ORDER_REQUEST,
      ROUTES.VENDOR_REQUEST,
      ROUTES.ORDER_PREVIEW_SHIFT,
      ROUTES.INVOICE_LISTING,
      ROUTES.ORDER_INVOICE_DETAIL,
      ROUTES.UPDATE_SHIFTS,
      ROUTES.RETURN_REQUEST,
      ROUTES.RETURN_ORDER_DETAIL,
    ],
    icon: Images.OrderSideIcon,
    icon_active: Images.OrderSideIcon,
    childs: [
      {
        name: 'Orders',
        path: [
          ROUTES.ORDERS_LIST,
          ROUTES.INVOICE_LISTING,
          ROUTES.ORDER_INVOICE_DETAIL,
        ],
        icon: Images.PRODUCTION_ACTIVE,
        icon_active: Images.PRODUCTION_ACTIVE,
      },
      {
        name: 'Order Requests',
        path: [ROUTES.ORDER_REQUEST],
        icon: Images.PRODUCTION_ACTIVE,
        icon_active: Images.PRODUCTION_ACTIVE,
      },
      {
        name: 'Vendor Requests',
        path: [ROUTES.VENDOR_REQUEST],
        icon: Images.PRODUCTION_ACTIVE,
        icon_active: Images.PRODUCTION_ACTIVE,
      },
      {
        name: 'Return Requests',
        path: [ROUTES.RETURN_REQUEST],
        icon: Images.PRODUCTION_ACTIVE,
        icon_active: Images.PRODUCTION_ACTIVE,
      },

      // {
      //   name: 'My Sets/Activity',
      //   path: [ROUTES.MY_SET],
      //   icon: Images.PRODUCTION_ACTIVE,
      //   icon_active: Images.PRODUCTION_ACTIVE,
      // },
      // {
      //   name: 'My Locations',
      //   path: [ROUTES.MY_LOCATIONS],
      //   icon: Images.PRODUCTION_ACTIVE,
      //   icon_active: Images.PRODUCTION_ACTIVE,
      // },
    ],
  },

  {
    name: 'Store',
    path: [
      '/store',
      '/store-search',
      '/store-vendor-details',
      '/store-product-details',
      '/store-service-details',
      '/store-package-details',
      '/store-vendors',
      '/store-services',
      '/store-packages',
      '/store-products',
      '/store-favorites',
      '/start-order',
      '/preview-shift',
    ],
    icon: Images.STORE_IC,
    icon_active: Images.STORE_IC,
    childs: [
      {
        name: 'Store',
        path: [
          ROUTES.STORE,
          '/store-search',
          '/store-vendor-details',
          '/store-product-details',
          '/store-service-details',
          '/store-package-details',
          '/store-vendors',
          '/store-services',
          '/store-packages',
          '/store-products',
          '/start-order',
          '/preview-shift',
        ],
        icon: Images.STORE_IC,
        icon_active: Images.PRODUCTION_ACTIVE,
      },
      {
        name: 'My Favorites',
        path: [ROUTES.STOREFAVOURITES],
        icon: Images.PRODUCTION_ACTIVE,
        icon_active: Images.PRODUCTION_ACTIVE,
      },
    ],
  },
  {
    name: 'Inbox',
    path: ['/chats'],
    icon: Images.ChatIcon,
    icon_active: Images.ChatIcon,
  },
  {
    name: 'Risk Center',
    path: [
      ROUTES.RISK_CENTER,
      ROUTES.PRODUCTION_SECURITY_DASHBOARD,
      ROUTES.EPIOSDE_SECURITY_DASHBOARD,
      ROUTES.SET_SECURITY_DASHBOARD,
      ROUTES.LOCATION_SECURITY_DASHBOARD,
      ROUTES.THREAT_DETAIL,
      ROUTES.ADD_THREAT,
      ROUTES.ACTIVE_THREATS,
    ],
    icon: Images.RISK_IC,
    icon_active: Images.RISK_IC,
  },

  // {
  //   name: 'Orders',
  //   path: ['/store'],
  //   icon: Images.Order_Icon,
  //   icon_active: Images.Order_Icon,
  //   childs: [
  //     {
  //       name: 'My orders',
  //       path: ['/store'],
  //       icon: Images.PRODUCTION_ACTIVE,
  //       icon_active: Images.PRODUCTION_ACTIVE,
  //     },
  //     {
  //       name: 'Draft Orders',
  //       path: ['/store'],
  //       icon: Images.PRODUCTION_ACTIVE,
  //       icon_active: Images.PRODUCTION_ACTIVE,
  //     },
  //     {
  //       name: 'Order Requests',
  //       path: ['/store'],
  //       icon: Images.PRODUCTION_ACTIVE,
  //       icon_active: Images.PRODUCTION_ACTIVE,
  //     },
  //   ],
  // },

  // {
  //   name: 'Store',
  //   path: ['/store'],
  //   icon: Images.STORE_IC,
  //   icon_active: Images.STORE_IC,
  //   childs: [
  //     {
  //       name: 'Store',
  //       path: ['/store'],
  //       icon: Images.PRODUCTION_ACTIVE,
  //       icon_active: Images.PRODUCTION_ACTIVE,
  //     },
  //     {
  //       name: 'My favourite',
  //       path: ['/store'],
  //       icon: Images.PRODUCTION_ACTIVE,
  //       icon_active: Images.PRODUCTION_ACTIVE,
  //     },
  //   ],
  // },

  // {
  //   name: 'Security',
  //   path: ['/store'],
  //   icon: Images.Security_Ic,
  //   icon_active: Images.Security_Ic,
  //   childs: [
  //     {
  //       name: 'Security Center',
  //       path: ['/store'],
  //       icon: Images.PRODUCTION_ACTIVE,
  //       icon_active: Images.PRODUCTION_ACTIVE,
  //     },
  //     {
  //       name: 'Security Personnel',
  //       path: ['/store'],
  //       icon: Images.PRODUCTION_ACTIVE,
  //       icon_active: Images.PRODUCTION_ACTIVE,
  //     },
  //   ],
  // },

  // {
  //   name: 'Safety',
  //   path: ['/store'],
  //   icon: Images.Safety_Ic,
  //   icon_active: Images.Safety_Ic,
  //   childs: [
  //     {
  //       name: 'Safety Center',
  //       path: ['/store'],
  //       icon: Images.PRODUCTION_ACTIVE,
  //       icon_active: Images.PRODUCTION_ACTIVE,
  //     },
  //     {
  //       name: 'Safety Personnel',
  //       path: ['/store'],
  //       icon: Images.PRODUCTION_ACTIVE,
  //       icon_active: Images.PRODUCTION_ACTIVE,
  //     },
  //   ],
  // },
];

export const ADDRESS_TYPES = {
  BUSINESS: 'BUSINESS',
  PERSONAL: 'PERSONAL',
};
export const DELIVERY_MODES: any = {
  'Hand it to me': 'inHand',
  'Leave it at Location': 'leftAtDoor',
  // 'Leave it at Lcation': 'leaveItAtLocation',
};
export const PRODUCTION_TYPE = {
  FEATURE_FILM: 'Feature Film',
  TV_SERIES: 'TV Series',
  // COMMERCIAL: 'Commercial',
  // DOCUMENTARY: 'Documentary',
  // MUSIC_VIDEO: 'Music Video',
  // EVENT: 'Event',
  // OTHER: 'Other',
};
export const businessType = [
  'State-Owned Business',
  'Publicly-Listed Business',
  'Privately-Owned Business',
  'Charity',
  'Other',
];
export const OrderStatusLabel: any = {
  CANCELLED: 'Canceled',
  PENDING: 'Pending',
  COMPLETED: 'Completed',
};

export const STATIC_CONTENT = {
  PRIVACY_POLICY: 'privacy_policy',
  TERMS_AND_CONDITION: 'terms_and_condition',
};
export enum STATIC_CONTENT_FAQ_CONTACT {
  'faqs',
  'contact-info',
}

export const dummyUrlLink =
  'https://app-development.s3.amazonaws.com/reel-track-dev%2F1710501373295';
export enum ORDER_PRODUCT_TYPES {
  rent = 'RENT',
  buy = 'BUY',
  service = 'SERVICE',
}
export const ORDER_STATUS = [
  {
    label: 'Completed',
    value: 'COMPLETED',
  },
  { label: 'Pending', value: 'PENDING' },
  { label: 'Canceled', value: 'CANCELED' },
];

export const PRODUCT_TYPE = [
  {
    label: 'Purchase',
    value: 'Purchase',
  },
  { label: 'Rental', value: 'Rental' },
  { label: 'Package', value: 'Package' },
  { label: 'Service', value: 'Service' },
];

export const max20CharsRegex = /^.{0,20}$/;

export const charAndNumbers = /^[a-zA-Z0-9]*$/; // Regex allows only alphabets and numbers

export enum NOTIFICATION_TYPES {
  'CHAT' = 'CHAT',
  'ORDER' = 'ORDER',
  'ORDER_REQUEST' = 'ORDER_REQUEST',
  'VENDOR_DOC_EXPIRED' = 'VENDOR_DOC_EXPIRED',
  'VENDOR_UPDATE_COMPANY' = 'VENDOR_UPDATE_COMPANY',
  'VENDOR_CHANGEPASS' = 'VENDOR_CHANGEPASS',
  'VENDOR_ONBOARDING' = 'VENDOR_ONBOARDING',
  'Vendor' = 'VENDOR',
  'PRODUCTION' = 'PRODUCTION',
  'STUDIO' = 'STUDIO',
  'INVOICE' = 'INVOICE',
  'RISK' = 'THREAT',
}

export const graphFilterValues: any = {
  Today: 'today',
  'Last 7 Days': 'last7Days',
  'Last 30 Days': 'last30Days',
  'Spend to Date': 'year',
  'All Orders': 'allOrders',
  'All Finance': 'allOrders',
};
export const graphFilterValuesLables: any = {
  Today: 'Today',
  'Last 7 Days': 'Last 7 Days',
  'Last 30 Days': 'Last 30 Days',
  'Spend to Date': 'Spend to Date',
  'All Orders': 'All Orders',
};

export const PRODUCTION_TYPES = [
  'Feature Film',
  ,
  'TV Series',
  ,
  'Multiple Live Events',
  ,
  'Live Event',
  ,
  'Commercial',
  ,
  'Documentary',
  'Music Video',
  'Other',
];

// DEVELOPMENT: 'Development',

export const scheduleTypes = [
  { label: 'Development', value: 'Development' },
  { label: 'Pre-Production', value: 'Pre-Production' },
  { label: 'Production', value: 'Production' },
  { label: 'Post-Production', value: 'Post-Production' },
  { label: 'Reshoot', value: 'Reshoot' },
];

export const setScheduleTypes = [
  { label: 'Development', value: 'Development' },
  { label: 'Prep', value: 'Prep' },
  { label: 'Shoot', value: 'Shoot' },
  { label: 'Strike', value: 'Strike' },
  { label: 'Hold', value: 'Hold' },
];

export const THEME_OPTIONS: ThemeOptions = {
  palette: {
    primary: {
      light: '#223a48',
      main: '#5089AC',
      dark: '#39617A',
      contrastText: '#fff',
    },
    secondary: {
      light: '#111927',
      main: '#EEF3F7',
      dark: '#e6f4ff',
      contrastText: '#5089AC',
    },
    error: {
      light: '#FEE4E2',
      main: '#F04438',
      dark: '#F04438',
      contrastText: '#F04438',
    },
    info: {
      light: '#FEE4E2',
      main: '#F04438',
      dark: '#e6f4ff',
      contrastText: '#F04438',
    },
    grey: {
      50: '#F9FAFB',
      100: '#F3F4F6',
      200: '#E5E7EB',
      300: '#D2D6DB',
      400: '#9DA4AE',
      500: '#6C737F',
      600: '#4D5761',
      700: '#384250',
      800: '#1F2A37',
      900: '#111927',
      A100: 'red',
      A200: 'blue',
      A400: 'green',
      A700: 'yellow',
    },
  },
  shape: {
    borderRadius: 8,
  },
  typography: {
    fontFamily: "'Poppins', sans-serif",
    fontSize: 14,
    fontWeightRegular: 400,
  },
};

export const colorsClassNames: any = {
  0: 'text-teal',
  1: 'text-purple',
  2: 'text-gold',
  3: 'text-cyan',
  4: 'text-ruby',
};

export const colorsNames = [
  '#00A0CE',
  '#9F49A2',
  '#FFA523',
  '#00B4B0',
  '#4C9F70',
];
export function getFileNameFromAWSURL(url: string) {
  const urlParts = url.split('/');
  return urlParts[urlParts.length - 1]?.replace(/\d+/g, '');
}

export const generalThreatLevelIndicators = [
  'General location assessment',
  'Online chatter',
];

export const TABLE_COLUMNS = {
  SET: 'set',
  LOCATION: 'location',
  SERVICE: 'service',
  EPISODE: 'episode',
  DATE: 'date',
} as const;

export const GROUP_CONFIG = {
  SET: {
    hiddenColumns: [TABLE_COLUMNS.SET],
  },
  LOCATION: {
    hiddenColumns: [TABLE_COLUMNS.LOCATION],
  },
  EPISODES: {
    hiddenColumns: [TABLE_COLUMNS.EPISODE],
  },
  ITEMS: {
    hiddenColumns: [TABLE_COLUMNS.SERVICE],
  },
  DATE: {
    hiddenColumns: [TABLE_COLUMNS.DATE],
  },
} as const;
